import firebase from 'firebase/app';
import 'firebase/functions';
import 'firebase/auth';
import { isBoolean, isString, } from 'joy-core';
import { toFirestoreAuthProvider } from '../support/FirestoreConversion';
import FirebaseAuthListener from '../listeners/FirebaseAuthListener';
export default class FirebaseAuthServiceProvider {
    async emailAuth(email, password) {
        let result = await firebase.functions().httpsCallable('httpsSignIn')({ email: email, password: password });
        let token = result.data['token'];
        if (isString(token)) {
            return token;
        }
        throw Error('Invalid input data received from httpsSignIn');
    }
    async tokenAuth(token, provider) {
        let result = await firebase.functions().httpsCallable('httpsThirdPartyAuth')({
            token: token,
            provider: toFirestoreAuthProvider(provider),
        });
        let newToken = result.data['token'];
        let isNewUser = result.data['isNewUser'];
        if (isString(token) && isBoolean(isNewUser)) {
            return { token: newToken, isNewUser };
        }
        throw Error('Invalid input data received from httpsThirdPartyAuth');
    }
    async sendResetPasswordEmail(email) {
        try {
            await firebase.functions().httpsCallable('httpsSendResetPasswordEmail')({ email: email });
            return true;
        }
        catch (error) {
            return false;
        }
    }
    async resetPassword(token, password) {
        try {
            await firebase.functions().httpsCallable('httpsResetPassword')({ token: token, password: password });
            return true;
        }
        catch (error) {
            return false;
        }
    }
    async createSession(token) {
        await firebase.auth().signInWithCustomToken(token);
        const userId = firebase.auth().currentUser.uid;
        if (isString(userId)) {
            return userId;
        }
        throw Error('Failed to authenticate with token: ' + token);
    }
    async getSession() {
        const userId = firebase.auth().currentUser.uid;
        if (isString(userId)) {
            return userId;
        }
        return null;
    }
    async deleteSession() {
        try {
            await firebase.auth().signOut();
            return true;
        }
        catch (error) {
            return false;
        }
    }
    authListener(action) {
        return new FirebaseAuthListener(action);
    }
    isAuthenticated() {
        return Boolean(firebase.auth().currentUser);
    }
}
//# sourceMappingURL=FirebaseAuthServiceProvider.js.map